import {
  createElement,
  Fragment,
  FunctionComponentElement,
  ReactNode,
} from 'react';
import { Toast } from 'react-hot-toast/dist/core/types';
export interface INotifyMessage {
  title: ReactNode;
  content?: ReactNode;
  config?: Partial<
    Pick<
      Toast,
      | 'id'
      | 'icon'
      | 'duration'
      | 'ariaProps'
      | 'className'
      | 'style'
      | 'position'
      | 'iconTheme'
    >
  >;
}

export const NotifyMessage = ({
  title,
  content,
}: INotifyMessage): FunctionComponentElement<Record<string, unknown>> => {
  const node = createElement(
    Fragment,
    null,
    createElement('h5', { className: 'notify-title' }, title),
    content && createElement('p', { className: 'notify-content' }, content),
  );
  return node;
};
